// media-utils.js — compatibilité média purement cliente.
// Aucun contenu ne quitte le navigateur et aucune conversion serveur n'est faite.

export const RECORDER_MIME_CANDIDATES = [
  'audio/mp4',
  'audio/webm;codecs=opus',
  'audio/ogg;codecs=opus',
  'audio/webm',
  'audio/ogg',
];

export function chooseRecorderMime(MediaRecorderCtor = globalThis.MediaRecorder) {
  if (!MediaRecorderCtor) return '';
  if (typeof MediaRecorderCtor.isTypeSupported !== 'function') return '';
  for (const mime of RECORDER_MIME_CANDIDATES) {
    try { if (MediaRecorderCtor.isTypeSupported(mime)) return mime; } catch (_) {}
  }
  return '';
}

export function extensionForMime(mime) {
  const m = typeof mime === 'string' ? mime.toLowerCase() : '';
  if (m.includes('mp4')) return 'm4a';
  if (m.includes('ogg')) return 'ogg';
  if (m.includes('webm')) return 'webm';
  return 'audio';
}

export function safeMediaPlay(media) {
  if (!media || typeof media.play !== 'function') return Promise.resolve(false);
  try {
    return Promise.resolve(media.play()).then(() => true).catch(() => false);
  } catch (_) {
    return Promise.resolve(false);
  }
}

export function isKnownWebKitMediaNoise(value) {
  const name = value?.name || '';
  const message = value?.message || String(value || '');
  const stack = value?.stack || '';
  return name === 'ReferenceError'
    && message.includes('EmptyRanges')
    && /played|syncControl|handleEvent/.test(stack);
}
